/* eslint-disable camelcase */
import * as THREE from 'three'
import { rotateGroup } from '../utils/helper_functions'
import { drawUnclickableTable } from './drawUnclickableTable'
import { drawLabel } from './drawLabel'
import { drawSeat } from './drawSeat'
import { COLORS, TIER_COLORS } from '../constants'
import { seats, textGeometries, materials } from '../utils/mapData'

export const colorIndex = {
  value: 0
}
export const tierColorObj = {}

export const resetColorsData = () => {
  colorIndex.value = 0
  for (const color in tierColorObj) {
    delete tierColorObj[color]
  }
}

export const drawGroupSeats = (group, groups, predefinedSeats, options) => {
  const {
    scene,
    scale,
    fonts,
    center_x,
    center_y,
    seat_circle_radius,
    events,
    enableTicketTypeAssign,
    selectedTierId,
    renderer,
    camera,
    sceneMeshes
  } = options
  const groupObj = new THREE.Group()
  group.x = group.x || 0
  group.y = -group.y || 0
  groupObj.position.set(group.x * scale, group.y * scale, 0)
  scene.add(groupObj)
  if (group.rotation && group.edges) {
    Object.keys(group.edges).forEach((key) => {
      group.edges[key].x *= scale
      group.edges[key].y *= scale
    })
    group.rotation && rotateGroup(groupObj, group.rotation, group.edges)
  }
  group.children.forEach((row, index) => {
    if (row.deleted === 0) {
      const rowLabelText = groups[group.id].groups[index].label
      row.children.forEach((seat, seatIndex) => {
        if (seat.deleted === 0) {
          const tierId = groups[group.id].groups[index].units[seatIndex].tier
          const seatLabelText =
            groups[group.id].groups[index].units[seatIndex].label
          const seatPosition = [seat.cx * scale, -seat.cy * scale, 0]
          const seatRotation =
            (seat.rotation || 0) + (row.rotation || 0) + (group.rotation || 0)

          if (!tierColorObj[tierId]) {
            tierColorObj[tierId] = TIER_COLORS[colorIndex.value]
            colorIndex.value++
          }

          if (seat.type === 'unclickable_table') {
            drawUnclickableTable({
              seats,
              materials,
              textGeometries,
              seatId: seat.id,
              seat,
              options: {
                color: COLORS.AVAILABLE,
                position: seatPosition,
                rotation: seatRotation,
                scene,
                center_x,
                center_y,
                scale,
                seat_circle_radius,
                parent: groupObj,
                events,
                sectionLabel: groups[group.id].label,
                rowLabel: rowLabelText,
                label: seatLabelText,
                fonts,
                type: seat.type,
                size: seat.size,
                tableShape: seat.table_shape,
                sceneMeshes
              }
            })
            return
          }
          drawSeat(seat.id, {
            color:
              predefinedSeats && predefinedSeats.includes(seat.id)
                ? COLORS.PREDEFINED
                : COLORS.AVAILABLE,
            position: seatPosition,
            rotation: seatRotation,
            tierId,
            scene,
            center_x,
            center_y,
            scale,
            seat_circle_radius,
            parent: groupObj,
            events,
            sectionLabel: groups[group.id].label,
            rowLabel: rowLabelText,
            label: seatLabelText,
            fonts,
            type: seat.type,
            seats,
            enableTicketTypeAssign,
            tierColor: tierColorObj[tierId],
            selectedTierId,
            camera,
            renderer,
            sceneMeshes
          })
        }
      })
    }
  })
  if (!group.hideSectionLabel) {
    const labelText = groups[group.id].label
    const labelPosition = [group.label_x * scale, -group.label_y * scale, 0]
    drawLabel(
      labelText,
      {
        font: fonts.openSans,
        color: 'black',
        position: labelPosition,
        center_x,
        center_y,
        scale,
        seat_circle_radius,
        scene: groupObj,
        size: group.label_size || seat_circle_radius * scale,
        rotation: group.label_rotation || 0
      },
      textGeometries,
      materials
    )
  }
  // sceneMeshes.push(seatMeshes)
}
